import React, { Component } from 'react'

export default class HoleStrokeIndicator extends Component {

    render() {
        var circles = [];
        var overPar = false;
        let maxStrokeOrPar = Math.max(this.props.par, this.props.stroke);
        let classname = "holeStroke";
        for (let index = 1; index <= maxStrokeOrPar; index++) {
       
            //add divider
            if(index > this.props.par){
                overPar = true;
            }
            if (index == this.props.par +1){
                //console.log("divider");
                circles.push(<div key={'divider'} style={{float:'left', fontSize:12}}>|</div>);
            }
            if(index > this.props.par + 1) {
                circles.splice(-1,1);
              //circles.push(<div className={classname} key={index+1} style={{backgroundColor: this.props.strokecolor,margin:1,color:'white', border:'solid 1px #000', width:12, height:12,float:'left',borderRadius: 10}}>{index}</div>);

              }
            if(!overPar){
                if (index < this.props.stroke){
                  //  console.log("black");
                    circles.push(<div className={classname} key={index} style={{backgroundColor: 'white',margin:1,color:'black', border:'solid 1px #000', width:12, height:12,float:'left',
                    borderRadius: 10, lineHeight: '12px'}}>{index}</div>);
                }
                else if (index > this.props.stroke){
                   // console.log("white");
                    circles.push(<div className={classname} key={index} style={{backgroundColor: 'white',margin:1, border:'solid 1px #000', width:12, height:12,float:'left',
                    borderRadius: 10, lineHeight: '12px'}}>{index}</div>);
                }
                else if (index == this.props.stroke){
                   //console.log("active yellow");
                    classname = classname + " blink_me";
                    if(this.props.strokecolor == "black" || this.props.strokecolor !== '#fac800'){
                        classname="holeStroke";
                    }
                    circles.push(<div className={classname} key={index} style={{backgroundColor: this.props.strokecolor,margin:1,color:'white', border:'solid 1px #000', width:12, height:12,float:'left',
                    borderRadius: 10, lineHeight: '12px'}}>{index}</div>);
                    classname="holeStroke";
                }
            }
            else {
                if(this.props.strokecolor === '#fac800'){
                    classname = classname + " blink_me";
                }
              circles.push(<div className={classname} key={index+1} style={{backgroundColor: this.props.strokecolor,margin:1,color:'white', border:'solid 1px #000', width:12, height:12,float:'left',borderRadius: 10, lineHeight: '12px'}}>{index}</div>);
             
            }
        
            
        }

        return (
            <div className="holeStrokeWrapper" style={{border:0, flexDirection:'row'}}>
                {circles}
                
            </div>

        );
        
        
    }

}

/*render() {
    var circles = [];
    var overPar = false;
    let maxStrokeOrPar = Math.max(this.props.par, this.props.stroke);
    let classname = "holeStroke";
    for (let index = 1; index <= maxStrokeOrPar; index++) {
   
        //console.log("index, stroke, par", index, this.props.stroke, this.props.par);
        //add divider
        if(index > this.props.par){
            overPar = true;
        }
        if (index == this.props.par +1){
            //console.log("divider");
            circles.push(<div key={'divider'} style={{float:'left'}}></div>);
        }
        if(!overPar){
            if (index < this.props.stroke){
               // console.log("black");
                circles.push(<div className={classname} key={index} style={{backgroundColor: 'black',margin:1, border:'solid 1px #000', width:8, height:8,float:'left',
                borderRadius: 10}}></div>);
            }
            else if (index > this.props.stroke){
               // console.log("white");
                circles.push(<div className={classname} key={index} style={{backgroundColor: 'white',margin:1, border:'solid 1px #000', width:8, height:8,float:'left',
                borderRadius: 10}}></div>);
            }
            else if (index == this.props.stroke){
               // console.log("active yellow");
                classname = classname + " blink_me";
                if(this.props.strokecolor == "black"){
                    classname="holeStroke";
                }
                circles.push(<div className={classname} key={index} style={{backgroundColor: this.props.strokecolor,margin:1, border:'solid 1px #000', width:8, height:8,float:'left',
                borderRadius: 10}}></div>);
                classname="holeStroke";
            }
        }
        else {
          circles.splice(-1,1);
           circles.push(<div style={{float:'left'}}key={"number"}><span style={{marginBottom:'4px'}}>|+{index - this.props.par}</span></div>);
        }
    
        
    }

    return (
        <div className="holeStrokeWrapper" style={{border:0, flexDirection:'row'}}>
            {circles}
            
        </div>

    );
    
    
}*/


// WEBPACK FOOTER //
// ./src/Components/Leaderboard/HoleStrokeIndicator.js